import { useMemo, useEffect } from 'react'
import { type CompleteEvent, Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
import { Box } from '@mui/material'
import 'survey-core/survey-core.min.css'
import './survey-overrides.css'

interface Props {
  surveyJson: any
  onComplete: (survey: Model, options: CompleteEvent) => void
  onLoad?: (survey: Model) => void
  themeJson?: any
  answers?: Record<string, any>
  saveSurvey?: (survey: Model, submit?: boolean) => Promise<void>
}

export function SurveyDisplay ({
  surveyJson,
  onComplete,
  onLoad,
  themeJson,
  answers,
  saveSurvey
}: Props): JSX.Element {
  const surveyModel = useMemo(() => {
    const model = new Model(surveyJson)

    const appliedTheme = themeJson ?? {
      isPanelless: true,
      cssVariables: {
        '--sjs-general-backcolor': 'transparent',
        '--sjs-general-backcolor-dim': 'transparent',
        '--sjs-paper-backcolor': 'transparent',
        '--sjs-paper-shadow': 'none'
      }
    }

    model.applyTheme(appliedTheme)
    model.widthMode = 'responsive'
    model.showTitle = false
    model.showQuestionNumbers = 'off'
    model.showNavigationButtons = 'none'
    model.showCompletedPage = false
    model.checkErrorsMode = 'onComplete'
    model.data = answers ?? {}

    model.onComplete.add(onComplete)

    return model
  }, [surveyJson, themeJson, onComplete, answers, saveSurvey])

  useEffect(() => {
    onLoad?.(surveyModel)
  }, [surveyModel, onLoad])

  return (
    <Box sx={{ width: '100%' }}>
      <Survey model={surveyModel} />
    </Box>
  )
}
